module.exports = __webpack_public_path__ + "static/media/PM50.4de4632c.png";